export default __webpack_public_path__ + "static/media/15-building-on-each-other.1582beed.svg";